import React from 'react'

import { MintButton } from '../../styles/PageLayout'

const BtnMintFour = ({ className, ...props }) => (
  <MintButton
    width="43"
    height="45"
    viewBox="0 0 43 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="0.5" y="0.5" width="42" height="44" fill="white" stroke="#591ED8" />
    <path d="M25.7754 14.4599V17.7426H26.7272V12.2715H25.7754V14.4599Z" fill="#591ED8" />
    <path d="M24.8242 18.8131V19.8835H25.776V17.7427H24.8242V18.8131Z" fill="#591ED8" />
    <path d="M26.7865 20.8348H29.8206V19.8833H25.7754V20.8348H26.7865Z" fill="#591ED8" />
    <path d="M29.8213 21.9051V22.9758H31.0111V20.835H29.8213V21.9051Z" fill="#591ED8" />
    <path d="M29.8213 26.3059H31.0111V24.165H29.8213V26.3059Z" fill="#591ED8" />
    <path d="M25.8354 32.7285H19.5889V33.9179H27.9173V32.7285H25.8354Z" fill="#591ED8" />
    <path d="M18.5181 31.7769H17.4473V32.7283H19.5889V31.7769H18.5181Z" fill="#591ED8" />
    <path
      d="M16.4157 30.6829H15.3845V21.9289H17.4469V20.835H14.3535V31.7771H17.4469V30.6829H16.4157Z"
      fill="#591ED8"
    />
    <path
      d="M26.8467 29.6362H24.8242V30.667H27.8581V32.7286H28.8695V29.6362H26.8467Z"
      fill="#591ED8"
    />
    <path
      d="M27.7979 26.3062H25.7754V27.4162H28.8093V29.6364H29.8206V26.3062H27.7979Z"
      fill="#591ED8"
    />
    <path d="M27.7587 22.9756H26.7275V24.165H29.821V22.9756H27.7587Z" fill="#591ED8" />
    <path d="M23.6344 13.3419V12.2715H22.6826V14.4123H23.6344V13.3419Z" fill="#591ED8" />
    <path d="M22.6823 15.4825V14.4121H21.7305V16.553H22.6823V15.4825Z" fill="#591ED8" />
    <path d="M21.7308 17.6237V16.5532H20.541V18.6941H21.7308V17.6237Z" fill="#591ED8" />
    <path d="M20.5407 18.6938H19.5889V19.8832H20.5407V18.6938Z" fill="#591ED8" />
    <path d="M19.5889 20.8348V19.8833H17.4473V20.8348H19.5889Z" fill="#591ED8" />
    <path
      d="M12.3312 31.658H11.3199V20.9538H14.3538V19.8833H10.3086V32.7285H14.3538V31.658H12.3312Z"
      fill="#591ED8"
    />
    <path d="M25.7754 12.2714V11.082H23.6338V12.2714H25.7754Z" fill="#591ED8" />
  </MintButton>
)

export default BtnMintFour
